<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData :coaching="coachingData"/>

        <Menu :coaching="coachingData"
              :currentUser="piniaCurrentUser"/>

        <!--        <transition name="fade">-->
        <!--          <div class="row" v-if="moduleInfoMessage">-->
        <!--            <div class="col-12">-->
        <!--              <div style="-->
        <!--                color: rgb(90, 90, 90);-->
        <!--                font-size: 16px;-->
        <!--                padding: 10px;-->
        <!--                background: #F8F8F8;-->
        <!--                border: 1px solid rgb(90, 90, 90);-->
        <!--                margin-bottom: 20px;-->
        <!--                border-radius: 3px">-->
        <!--                {{ moduleInfoMessage }}-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </transition>-->


        <transition name="fade">
          <div class="row" v-if="unitsErrorMessage || terminErrorMessage || moduleUnitsErrorMessage">
            <div class="col-12">
              <div style="
                color: #e65252;
                font-size: 16px;
                padding: 10px;
                background: #F8F8F8;
                border: 1px solid #e65252;
                margin-bottom: 20px;
                border-radius: 3px">
                {{ unitsErrorMessage }} {{ terminErrorMessage }} {{ moduleUnitsErrorMessage }}
              </div>
            </div>
          </div>
        </transition>

        <div v-if="missingDigitalSignatureMessage !== null && missingDigitalSignatureMessage !== ''"
             style="
                  margin-top: 5px;
                  color: #e65252;
                  font-size: 17px;
                  padding: 10px;
                  background: #F8F8F8;
                  border: 1px solid #e65252;
                  margin-bottom: 30px;
                  border-radius: 3px;">
          {{ missingDigitalSignatureMessage }}
        </div>

        <div v-if="showUpdateAsAdminButton" class="row mb-5" style="border-bottom: 1px solid #D8D8D8">
          <div class="col text-right" style="font-size: 17px;">{{ $t('general.update_as_admin') }}</div>
          <div class="col-auto text-right">
            <BaseToggle v-model="updateAsAdmin" @change="onChangeUpdateAsAdmin"/>
          </div>
        </div>

        <form @submit.prevent="submitForm" class="mt-4" novalidate>
          <div class="row">
            <div class="col-lg-2 col-md-4 col-sm-6 col-12  ">
              <Datepicker
                  v-model="formData.termin"
                  :disabled="isBilled || isCoachBilled"
                  :required="true"
                  label="Termin"
                  position="down"
                  :validation="v$.termin"
                  :messages="v$.termin.required.$message"
                  @update:modelValue="onChangeTermin"/>
            </div>
            <div class="col-lg-4 col-md-8 col-sm-12  ">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <Timepicker
                      :key="startTimeKey"
                      v-model="formData.startTime"
                      :disabled="isBilled || isCoachBilled"
                      :required="true"
                      :hoursArray=hoursArray
                      :minutesArray='["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]'
                      label="Startzeit"
                      @update:modelValue="calculateTimeDifference"/>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <Timepicker
                      :key="endTimeKey"
                      v-model="formData.endTime"
                      :disabled="isBilled || isCoachBilled"
                      :required="true"
                      :hoursArray=hoursArray
                      :minutesArray='["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]'
                      label="Endzeit"
                      @update:modelValue="calculateTimeDifference"/>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <SelectVue
                  v-model="formData.presence"
                  :disabled="isBilled || isCoachBilled"
                  :options="presenceDropdown"
                  :required="true"
                  label="Anwesenheit"
                  placeholder="Wählen Sie Anwesenheit"
                  :validation="v$.presence"
                  :messages="v$.presence.required.$message"
                  @update:modelValue="onChangePresence"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <BaseNumber
                  v-model="formData.units"
                  label="Einheiten"
                  disabled="disabled"/>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-lg-2 col-md-4 col-sm-12">
              <BaseCheckbox
                  :disabled="isBilled || isCoachBilled || coachingData?.requiresSignature"
                  v-model="formData.signature"
                  label="Unterschrift"
                  :required="true"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12"
                 v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
              <BaseCheckbox
                  :disabled="isBilled"
                  v-model="formData.billed"
                  label="Abgerechnet"
                  :required="true"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12"
                 v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
              <BaseCheckbox
                  v-model="formData.paid"
                  :disabled="isCoachBilled"
                  label="Bezahlt"
                  :required="true"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <BaseCheckbox
                  :disabled="isBilled || isCoachBilled"
                  v-model="formData.homeVisit"
                  label="Hausbesuch"
                  :required="true"
                  :labelPosition="'right'"/>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-lg-4 col-md-8 col-sm-12">
              <SelectVue
                  v-model="formData.coachId"
                  :disabled="isCoachBilled"
                  :options="coachDropdown"
                  :required="true"
                  :is-clear="true"
                  label="Coach"
                  placeholder="Trainer auswählen"
                  v-if="
                    currentUserRole === 'ROLE_ADMIN' ||
                    currentUserRole === 'ROLE_SITE_SUPPORT' ||
                    currentUserRole === 'ROLE_SITE_MANAGER' ||
                    currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                    currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                    currentUserRole === 'ROLE_ACCOUNTANT'"/>
            </div>

            <FirstInterviewSignaturePanel
                :operationType="operationType"
                :currentUserRole="currentUserRole"
                :firstInterviewId="firstInterviewId"
                :currentDigitalSignature="currentDigitalSignature"
                :isDigitalSignature="isDigitalSignature"
                :missingDigitalSignatureForFirstInterview="missingDigitalSignatureForFirstInterview"
                :updatedByAdmin="updatedByAdmin"
                :canSeeMeetingHistory="canSeeMeetingHistory"
                @open-history="handleMeetingHistoryModal"
                @open-signature="handleDigitalSignatureModal"/>

          </div>

          <!-- GOALS FROM PREVIOUS MEETING  -->
          <div class="row mt-4" style="border-top: 1px solid #D8D8D8"
               v-if="formData.moduleGoal4IdFromLastMeeting">
            <div class="col-lg-4 col-md-8 col-sm-12 mt-3">
              <SelectVue
                  v-model="formData.moduleGoal5IdFromLastMeeting"
                  :disabled="isBilled || isCoachBilled"
                  :options="moduleGoal5LastMeetingDropdown"
                  :is-clear="true"
                  label="Kontrolle vereinbarte Ziele"
                  placeholder="Wählen Sie Modulziel"
                  @update:modelValue="onChangeGoalFromLastMeeting"/>
            </div>
            <div class="col-lg-4 col-md-8 col-sm-12 mt-3">
              <SelectVue
                  v-model="formData.moduleGoal6IdFromLastMeeting"
                  :disabled="isBilled || isCoachBilled"
                  :options="moduleGoal6LastMeetingDropdown"
                  :is-clear="true"
                  label="Handlungsempfehlung"
                  placeholder="Wählen Sie Modulziel"/>
            </div>
          </div>

          <div class="row mt-4" style="border-top: 1px solid #D8D8D8">
            <div class="col-lg-6 col-md-8 col-sm-12 mt-3">
              <SelectVue
                  v-model="formData.moduleId"
                  :disabled="isBilled || isCoachBilled"
                  :options="moduleDropdown"
                  :required="true"
                  :is-clear="true"
                  label="Modul"
                  placeholder="Modul auswählen"
                  :validation="v$.moduleId"
                  :messages="v$.moduleId.required.$message"
                  @update:modelValue="onChangeModule"/>
            </div>
            <div v-if="(
                currentUserRole === 'ROLE_ADMIN' ||
                currentUserRole === 'ROLE_ACCOUNTANT'
                ) && firstInterviewId"
                 class="col-lg-2 col-md-4 col-sm-12 mt-3 position-relative">
              <div class="position-absolute" style="right: 0; padding-right: 10px;">
                <div class="status-pill p-2 rounded-full"
                     :class="{
                            green: checkMissingMeetingForSectionNumber(
                                sectionNumberList,
                                originalSectionNumber
                            ),
                            red: !checkMissingMeetingForSectionNumber(
                                sectionNumberList,
                                originalSectionNumber
                            )
                        }">
                </div>
              </div>
              <BaseNumber
                  v-model="formData.sectionNumber"
                  :validation="v$.sectionNumber"
                  :messages="v$.sectionNumber?.required?.$message"
                  :label="$t('general.section')"
                  :disabled="!updateAsAdmin"/>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-8 col-sm-12">
              <SelectVue
                  v-model="formData.moduleGoal1Id"
                  :disabled="isBilled || isCoachBilled"
                  :options="moduleGoal1Dropdown"
                  :required="true"
                  :is-clear="true"
                  label="Richtziel"
                  placeholder="Wählen Sie Modulziel"
                  @update:modelValue="(newValue) => onChangeGoal(newValue, 1)"
                  :validation="v$.moduleGoal1Id"
                  :messages="v$.moduleGoal1Id?.required?.$message"/>
            </div>
            <div class="col-lg-6 col-md-8 col-sm-12">
              <SelectVue
                  v-model="formData.moduleGoal2Id"
                  :disabled="isBilled || isCoachBilled"
                  :options="moduleGoal2Dropdown"
                  :required="true"
                  :is-clear="true"
                  label="Grobziel"
                  placeholder="Wählen Sie Modulziel"
                  @update:modelValue="(newValue) => onChangeGoal(newValue, 2)"
                  :validation="v$.moduleGoal2Id"
                  :messages="v$.moduleGoal2Id?.required?.$message"/>
            </div>
            <div class="col-lg-6 col-md-8 col-sm-12">
              <SelectVue
                  v-model="formData.moduleGoal3Id"
                  :disabled="isBilled || isCoachBilled"
                  :options="moduleGoal3Dropdown"
                  :required="true"
                  :is-clear="true"
                  label="Feinziel"
                  placeholder="Wählen Sie Modulziel"
                  @update:modelValue="(newValue) => onChangeGoal(newValue, 3)"
                  :validation="v$.moduleGoal3Id"
                  :messages="v$.moduleGoal3Id?.required?.$message"/>
            </div>
            <div class="col-lg-6 col-md-8 col-sm-12">
              <SelectVue
                  v-model="formData.moduleGoal4Id"
                  :disabled="isBilled || isCoachBilled"
                  :options="moduleGoal4Dropdown"
                  :required="true"
                  :is-clear="true"
                  label="Maßnahmen"
                  placeholder="Wählen Sie Modulziel"
                  @update:modelValue="(newValue) => onChangeGoal(newValue, 4)"
                  :validation="v$.moduleGoal4Id"
                  :messages="v$.moduleGoal4Id?.required?.$message"/>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-8 col-sm-12">
              <Datepicker
                  v-model="formData.moduleGoalDate"
                  :disabled="isBilled || isCoachBilled"
                  label="Bis wann"
                  position="down"/>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-8 col-sm-12">
              <SelectVue
                  v-model="formData.moduleGoal5Id"
                  :disabled="isBilled || isCoachBilled"
                  :options="moduleGoal5Dropdown"
                  :is-clear="true"
                  label="Zielkontrolle"
                  placeholder="Wählen Sie Modulziel"
                  @update:modelValue="(newValue) => onChangeGoal(newValue, 5)"/>
            </div>
            <div class="col-lg-6 col-md-8 col-sm-12">
              <SelectVue
                  v-model="formData.moduleGoal6Id"
                  :disabled="isBilled || isCoachBilled"
                  :options="moduleGoal6Dropdown"
                  :is-clear="true"
                  label="Handlungsempfehlung"
                  placeholder="Wählen Sie Modulziel"
                  @update:modelValue="(newValue) => onChangeGoal(newValue, 6)"/>
            </div>
          </div>


          <div v-if="formData.presenceRemainder" class="mt-2">
            <BaseTextArea
                v-model="formData.presenceRemainder"
                disabled="disabled"
                label="Prüfung Anwesenheit"/>
          </div>
          <div v-if="showAdditionalDropdown" class="col-lg-4 col-md-8 col-sm-12 pl-0">
            <SelectVue
                v-model="formData.presenceRemainderAcceptance"
                :options="generatePresenceRemainderAcceptanceDropdown"
                :is-clear="true"
                disabled=disabled
                placeholder="Wählen Sie ..."/>
          </div>
          <div v-if="formData.systemAddedMeetingDescription" class="mt-3">
            <BaseInput
                v-model="formData.systemAddedMeetingDescription"
                disabled=disabled
                label="Selbstlernphase Anwesenheit"/>
          </div>

          <div class="row mt-3">
            <div class="col-12 mb-2">
              <span style="font-size: 16px; text-decoration: underline">Beschreibung des Modulziels</span>
            </div>
            <div class="col-12 mb-2">
              <span style="font-weight: bolder; margin-right: 15px;">Richtziel:</span>{{ goal1Name }} <span
                class="moduleGoal1Name pl-1"></span>
            </div>
            <div class="col-12 mb-2">
              <span style="font-weight: bolder;  margin-right: 15px;">Grobziel:</span> {{ goal2Name }} <span
                class="moduleGoal2Name pl-1"></span>
            </div>
            <div class="col-12 mb-2">
              <span style="font-weight: bolder;  margin-right: 15px;">Feinziel:</span> {{ goal3Name }} <span
                class="moduleGoal3Name pl-1"></span>
            </div>
            <div class="col-12 mb-2">
              <span style="font-weight: bolder;  margin-right: 15px;"> Maßnahmen:</span> {{ goal4Name }} <span
                class="moduleGoal4Name pl-1"></span>
            </div>
            <div class="col-12 mb-2">
              <span style="font-weight: bolder;  margin-right: 15px;"> Handlungsempfehlung:</span> {{ goal6Name }} <span
                class="moduleGoal6Name pl-1"></span>
            </div>
          </div>

          <div class="accordion mt-5">
            <!-- Accordion Item 1 -->
            <div class="accordion-item">
              <div class="accordion-header" @click="toggleAccordion(1)">
                <h6 :style="{ color: 'var(--primary)' }">Ressourcen und Kompetenzen</h6>
              </div>
              <div v-if="activeAccordion === 1" class="accordion-body">
                <AccordionItemResourceAndSkills
                    title="Ressourcen und Kompetenzen"
                    :items="formData.resourceAndSkills"
                    :resourceDropdown="resourceDropdown"
                    :professionalSkillsDropdown="professionalSkillsDropdown"
                    :competenciesDropdown="competenciesDropdown"
                    :actionSkillsDropdown="actionSkillsDropdown"
                    :communicativeSkillsDropdown="communicativeSkillsDropdown"
                    :emotionalSkillsDropdown="emotionalSkillsDropdown"
                    :socialSkillsDropdown="socialSkillsDropdown"
                    @addItem="(newItem) => addItem('resourceAndSkills', newItem)"
                    @deleteItem="(index) => removeItem('resourceAndSkills', index)"/>
              </div>
            </div>

            <!-- Accordion Item 2 -->
            <div class="accordion-item">
              <div class="accordion-header" @click="toggleAccordion(2)">
                <h6 :style="{ color: 'var(--primary)' }">Lebenslauf</h6>
              </div>
              <div v-if="activeAccordion === 2" class="accordion-body">
                <AccordionItem
                    title="Beruflicher Werdegang"
                    :items="formData.professionalBackgrounds"
                    itemTitleLabel="Zeitraum"
                    itemDescriptionLabel="Beschreibung"
                    @addItem="(newItem) => addItem('professionalBackgrounds', newItem)"
                    @deleteItem="(index) => removeItem('professionalBackgrounds', index)"/>
                <AccordionItem
                    title="Bildungsweg"
                    :items="formData.educationalPaths"
                    itemTitleLabel="Zeitraum"
                    itemDescriptionLabel="Beschreibung"
                    @addItem="(newItem) => addItem('educationalPaths', newItem)"
                    @deleteItem="(index) => removeItem('educationalPaths', index)"/>
                <AccordionItemDescription
                    title="Besondere Kenntnisse"
                    :items="formData.specialKnowledge"
                    itemDescriptionLabel="Beschreibung"
                    @addItem="(newItem) => addItem('specialKnowledge', newItem)"
                    @deleteItem="(index) => removeItem('specialKnowledge', index)"/>
                <AccordionItem
                    title="Interessen"
                    :items="formData.interests"
                    itemTitleLabel="Zeitraum"
                    itemDescriptionLabel="Beschreibung"
                    @addItem="(newItem) => addItem('interests', newItem)"
                    @deleteItem="(index) => removeItem('interests', index)"/>
              </div>
            </div>
          </div>


          <ValidationErrorMessage :validationErrors=v$?.$errors></ValidationErrorMessage>

          <div class="row text-center mt-3" v-if="!isResourcesAndSkillsValid">
            <div class="col-12">
              <span style="font-size: 16px; color: red">
                Um einen vollständigen Bericht zu erzeugen, muss mindestens 1 Wert bei Ressourcen/Kompetenzen gewählt werden
              </span>
            </div>
          </div>

          <div
              v-if="
              !unitsErrorMessage &&
              !terminErrorMessage &&
              !moduleUnitsErrorMessage &&
              isResourcesAndSkillsValid &&
              canSeeCreateNewMeetingButton"
              class="d-flex justify-content-center w-100 mt-4">
            <SaveButton
                :label="$t('general.button.save')"
                :loading="isSubmitting"/>
          </div>
        </form>
      </div>
    </div>

    <Modal
        v-model="showDigitalSignatureModal"
        title="Digitale Unterschrift"
        :hide-cancel="true"
        :button-label="$t('general.button.save')"
        sizeModal="modal-md"
        :hide-footer="true"
        classFooter="justify-content-center">
      <PrivateCoachingDigitalSignatureForm
          :meetingId="firstInterviewId"
          :coachingId="coachingId"
          meetingType="firstInterview"
          v-model:missingDigitalSignature="missingDigitalSignatureForFirstInterview"
          v-model:submitForm="submitFormWatch"/>
    </Modal>

    <Modal
        title="Begegnungsgeschichte"
        :button-label="$t('general.button.save')"
        :customWidth="'1400px'"
        v-model="showMeetingHistoryModal"
        :hide-footer="true"
        classFooter="justify-content-center">
      <MeetingHistoryList
          :meetingId="firstInterviewId"
          :operationType="operationType"/>
    </Modal>
  </PageTemplate>
</template>

<script setup>
import portalPrivateCoachingService from '@/api/Portal/PrivateCoaching';
import privateCoachingService from '@/api/Unemployed/PrivateCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import BaseTextArea from '@/components/base/BaseTextArea.vue';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import Timepicker from '@/components/picker/Timepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import ValidationErrorMessage from '@/components/ValidationErrorMessage.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
import {addDeletedCoachToDropdown, addDeletedModuleToDropdown} from '@/shared/portal/commonFunctions';
import {
  canSeeMeetingHistory,
  checkCoachingStartDateForMICV2,
  generateActionSkillsDropdown,
  generateCommunicativeSkillsDropdown,
  generateCompetenciesDropdown,
  generateEmotionalSkillsDropdown,
  generateHoursArray,
  generatePresenceRemainderAcceptanceDropdown,
  generateProfessionalSkillsDropdown,
  generateResourcesDropdown,
  generateSocialSkillsDropdown,
  getAssignedCoachesForDropdown,
  getAssignedModulesForDropdown,
  handleGoalChange,
  mapData,
  portalPrivateCoachingCheckModule,
} from '@/shared/portal/privateCoachingFunctions';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import CoachingOverviewData from '@/views/App/Portal/PrivateCoaching/CoachingOverviewData.vue';
import AccordionItem from '@/views/App/Portal/PrivateCoaching/FirstInterview/Accordion/AccordionItem.vue';
import AccordionItemDescription
  from '@/views/App/Portal/PrivateCoaching/FirstInterview/Accordion/AccordionItemDescription.vue';
import AccordionItemResourceAndSkills
  from '@/views/App/Portal/PrivateCoaching/FirstInterview/Accordion/AccordionItemResourceAndSkills.vue';
import Menu from '@/views/App/Portal/PrivateCoaching/Menu.vue';
import PrivateCoachingDigitalSignatureForm
  from '@/views/App/Portal/PrivateCoaching/PrivateCoachingDigitalSignatureForm.vue';
import useVuelidate from '@vuelidate/core';
import {computed, onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import BaseToggle from "@/components/base/BaseToggle.vue";
import MeetingHistoryList from "@/views/App/Portal/PrivateCoaching/MeetingHistoryList.vue";
import FirstInterviewSignaturePanel from "@/components/FirstInterviewSignaturePanel.vue";
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import SaveButton from '@/components/button/SaveButton.vue';

const micNewUnitsCalculationStartFrom = process.env.VUE_APP_MIC_NEW_UNITS_CALCULATION_START_FROM
const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState?.currentUser?.user);
const currentUserRole = piniaCurrentUser?.value?.roles[0];
const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)
const companyKey = companySettings.value.companyKey;

const {t} = useI18n();
const coachingData = ref('');
const route = useRoute();
const coachingId = route.params.id;
const firstInterviewId = ref('');
const operationType = ref('');
const presenceDropdown = ref([]);
const coachDropdown = ref([]);
const moduleDropdown = ref([]);
const doctorTypeDropdown = ref([]);
const assistanceTypeDropdown = ref([]);
const graduationTypeDropdown = ref([]);
const moduleGoal1Dropdown = ref([]);
const moduleGoal2Dropdown = ref([]);
const moduleGoal3Dropdown = ref([]);
const moduleGoal4Dropdown = ref([]);
const moduleGoal5Dropdown = ref([]);
const moduleGoal6Dropdown = ref([]);
const moduleGoal5LastMeetingDropdown = ref([]);
const moduleGoal6LastMeetingDropdown = ref([]);
const goal1Name = ref('');
const goal2Name = ref('');
const goal3Name = ref('');
const goal4Name = ref('');
const goal6Name = ref('');
const unitsErrorMessage = ref('');
const terminErrorMessage = ref('');
const moduleUnitsErrorMessage = ref('');
const moduleInfoMessage = ref('');
const resourceDropdown = ref([]);
const professionalSkillsDropdown = ref([]);
const competenciesDropdown = ref([]);
const actionSkillsDropdown = ref([]);
const communicativeSkillsDropdown = ref([]);
const emotionalSkillsDropdown = ref([]);
const socialSkillsDropdown = ref([]);
const hoursArray = generateHoursArray(7, 20);
const showAdditionalDropdown = ref(false);
const isLoaded = ref(false);
const isSubmitting = ref(false);
const isBilled = ref(false);
const isCoachBilled = ref(false);
const isProcessingChangeTermin = ref(false);
const activeAccordion = ref(null); // Tracks the currently open accordion item
const missingDigitalSignatureMessage = ref(null);
const isDigitalSignature = ref(false);
const showDigitalSignatureModal = ref(false);
const submitFormWatch = ref(false);
const missingDigitalSignatureForFirstInterview = ref(false);
const updateAsAdmin = ref(false)
const originalIsBilled = ref(false); // Need this for update as admin logic
const originalIsCoachBilled = ref(false); // Need this for update as admin logic
const originalSectionNumber = ref(0) // Need this for update as admin logic
const sectionNumberList = ref([])
const updatedByAdmin = ref(false)
const showMeetingHistoryModal = ref(false)
const startValidateResourceAndSkills = ref(false)
const currentDigitalSignature = ref(null)
const isUnitsReduction = ref(false)

watch(submitFormWatch, async () => {
  showDigitalSignatureModal.value = false;
  await getFirstInterviewData(coachingId);
});

const formData = ref({
  termin: '',
  startTime: '07:00',
  endTime: '07:00',
  presence: '',
  units: 0,
  adjustedUnits: 0,
  signature: false,
  billed: false,
  paid: false,
  homeVisit: false,
  coachId: null,
  moduleId: null,
  sectionNumber: null,
  moduleGoal1Id: null,
  moduleGoal2Id: null,
  moduleGoal3Id: null,
  moduleGoal4Id: null,
  moduleGoal5Id: null,
  moduleGoal6Id: null,
  moduleGoalDate: null,
  lastMeetingId: null,
  moduleIdFromLastMeeting: null,
  moduleGoal4IdFromLastMeeting: null,
  moduleGoal5IdFromLastMeeting: null,
  moduleGoal6IdFromLastMeeting: null,
  systemAddedMeetingDescription: '',
  presenceRemainder: '',
  presenceRemainderAcceptance: '',
  resourceAndSkills: [],
  professionalBackgrounds: [],
  educationalPaths: [],
  specialKnowledge: [], // Only description field
  interests: [],
});

const originalFormData = ref({});
const originalModuleGoalDropdowns = ref([])
// This key will force the Timepicker to re-create when changed
const startTimeKey = ref(formData.value.startTime);
const endTimeKey = ref(formData.value.endTime);

const formRules = ref({
  termin: requiredRule(t),
  startTime: requiredRule(t),
  endTime: requiredRule(t),
  presence: requiredRule(t),
  units: requiredRule(t),

  signature: requiredRule(t),
  billed: requiredRule(t),
  paid: requiredRule(t),
  homeVisit: requiredRule(t),
  moduleId: requiredRule(t),
  moduleGoal1Id: requiredRule(t),
  moduleGoal2Id: requiredRule(t),
  moduleGoal3Id: requiredRule(t),
  moduleGoal4Id: requiredRule(t),
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  startValidateResourceAndSkills.value = true;
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {

    if (!isResourcesAndSkillsValid.value) {
      return
    }

    formData.value.coachingId = +coachingId;
    formData.value.operationType = operationType.value;
    formData.value.units = Number(formData.value.units);// or parseFloat if you prefer
    formData.value.adjustedUnits = Number(formData.value.adjustedUnits);

    formData.value.moduleGoal1Id = normalizeId(formData.value.moduleGoal1Id);
    formData.value.moduleGoal2Id = normalizeId(formData.value.moduleGoal2Id);
    formData.value.moduleGoal3Id = normalizeId(formData.value.moduleGoal3Id);
    formData.value.moduleGoal4Id = normalizeId(formData.value.moduleGoal4Id);
    formData.value.moduleGoal5Id = normalizeId(formData.value.moduleGoal5Id);
    formData.value.moduleGoal6Id = normalizeId(formData.value.moduleGoal6Id);
    formData.value.moduleGoal5IdFromLastMeeting = normalizeId(formData.value.moduleGoal5IdFromLastMeeting);
    formData.value.moduleGoal6IdFromLastMeeting = normalizeId(formData.value.moduleGoal6IdFromLastMeeting);

    const valGoal6IdLastMeeting = formData.value.moduleGoal6IdFromLastMeeting;
    if (valGoal6IdLastMeeting === '' || valGoal6IdLastMeeting === 'null' || valGoal6IdLastMeeting == null) {  // catches '', 'null', null, undefined
      formData.value.moduleGoal6IdFromLastMeeting = null;
    } else {
      formData.value.moduleGoal6IdFromLastMeeting = Number(valGoal6IdLastMeeting);
    }

    if (firstInterviewId.value) {
      if (updateAsAdmin.value) {
        await portalPrivateCoachingService.updateAsAdminMICFirstInterviewV2(formData.value, +firstInterviewId.value);
      } else {
        await portalPrivateCoachingService.updateMICFirstInterviewV2(formData.value, +firstInterviewId.value);
      }
    } else {
      await portalPrivateCoachingService.createMICFirstInterviewV2(formData.value);
    }

    await getFirstInterviewData(coachingId);
    await getPrivateCoachingData(coachingId);

    activeAccordion.value = null;
    updateAsAdmin.value = false // IMPORTANT !!!
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getPrivateCoachingData(privateCoachingId) {
  try {
    CloseToast();
    const {data} = await privateCoachingService.getPrivateCoaching(+privateCoachingId);
    coachingData.value = data.data;
    operationType.value = data.data?.nameOfCoaching.operationType;
    isDigitalSignature.value = data.data?.digitalSignature;
    isUnitsReduction.value = data.data.client.unitsReduction
  } catch (error) {
    await router.push({name: 'privateCoachingNewAndActiveList'});
    await ErrorToast(error);
  }
}

async function getFirstInterviewData(privateCoachingId) {

  try {
    const {data} = await portalPrivateCoachingService.getFirstInterviewData(privateCoachingId);

    const {firstInterview} = data?.data;
    const additionalDropdown = data.data?.showAdditionalDropdown;
    missingDigitalSignatureMessage.value = data.data?.missingDigitalSignatureMessage;
    sectionNumberList.value = data.data?.sectionNumberList

    if (firstInterview) {
      currentDigitalSignature.value = firstInterview?.digitalSignatureBase64;

      if (!firstInterview.digitalSignatureImage) {
        missingDigitalSignatureForFirstInterview.value = true;
      }

      isBilled.value = firstInterview.invoiced;
      isCoachBilled.value = firstInterview.coachInvoiced;
      updatedByAdmin.value = firstInterview.updatedByAdmin

      // Save original values
      originalIsBilled.value = firstInterview.invoiced;
      originalIsCoachBilled.value = firstInterview.coachInvoiced;
      originalSectionNumber.value = firstInterview.sectionNumber

      showAdditionalDropdown.value = additionalDropdown;

      const moduleGoalDropdowns = firstInterview?.moduleGoalDropdownOptions;
      const professionalBackgroundsData = mapData(firstInterview?.professionalBackgrounds || []);
      const educationalPathsData = mapData(firstInterview?.educationalPaths || []);
      const specialKnowledgeData = mapData(firstInterview?.specialKnowledge || []);
      const interestsData = mapData(firstInterview?.interests || []);

      moduleGoal1Dropdown.value = moduleGoalDropdowns?.goal1Dropdown || [];
      moduleGoal2Dropdown.value = moduleGoalDropdowns?.goal2Dropdown || [];
      moduleGoal3Dropdown.value = moduleGoalDropdowns?.goal3Dropdown || [];
      moduleGoal4Dropdown.value = moduleGoalDropdowns?.goal4Dropdown || [];
      moduleGoal5Dropdown.value = moduleGoalDropdowns?.goal5Dropdown || [];
      moduleGoal6Dropdown.value = moduleGoalDropdowns?.goal6Dropdown || [];
      moduleGoal5LastMeetingDropdown.value = moduleGoalDropdowns?.goal5FromLastMeetingDropdown || [];
      moduleGoal6LastMeetingDropdown.value = moduleGoalDropdowns?.goal6FromLastMeetingDropdown || [];
      goal1Name.value = firstInterview?.moduleGoal1?.name;
      goal2Name.value = firstInterview?.moduleGoal2?.name;
      goal3Name.value = firstInterview?.moduleGoal3?.name;
      goal4Name.value = firstInterview?.moduleGoal4?.name;
      goal6Name.value = firstInterview?.moduleGoal6?.name;

      addDeletedCoachToDropdown(firstInterview?.coach, coachDropdown);
      addDeletedModuleToDropdown(firstInterview?.module, moduleDropdown);

      firstInterviewId.value = firstInterview?.id;

      if (firstInterview.presence === 'unentschuldigt' || firstInterview.presence === 'krank') {
        formRules.value = {
          ...formRules.value,
          moduleGoal1Id: '',
          moduleGoal2Id: '',
          moduleGoal3Id: '',
          moduleGoal4Id: '',
        };
      } else {
        formRules.value = {
          ...formRules.value,
          moduleGoal1Id: requiredRule(t),
          moduleGoal2Id: requiredRule(t),
          moduleGoal3Id: requiredRule(t),
          moduleGoal4Id: requiredRule(t),
        };
      }

      formData.value = {
        ...firstInterview,
        coachId: firstInterview?.coach?.id,
        moduleId: firstInterview?.module?.id,
        lastMeetingId: firstInterview.previousMeetingId,
        moduleGoal1Id: firstInterview?.moduleGoal1?.id ? firstInterview?.moduleGoal1?.id : null,
        moduleGoal2Id: firstInterview?.moduleGoal2?.id ? firstInterview?.moduleGoal2?.id : null,
        moduleGoal3Id: firstInterview?.moduleGoal3?.id ? firstInterview?.moduleGoal3?.id : null,
        moduleGoal4Id: firstInterview?.moduleGoal4?.id ? firstInterview?.moduleGoal4?.id : null,
        moduleGoal5Id: firstInterview?.moduleGoal5?.id ? firstInterview?.moduleGoal5?.id : null,
        moduleGoal6Id: firstInterview?.moduleGoal6?.id ? firstInterview?.moduleGoal6?.id : null,
        moduleIdFromLastMeeting: firstInterview?.moduleFromLastMeeting?.id,
        moduleGoal4IdFromLastMeeting: firstInterview?.moduleGoal4FromLastMeeting?.id ? firstInterview?.moduleGoal4FromLastMeeting?.id : null,
        moduleGoal5IdFromLastMeeting: firstInterview?.moduleGoal5FromLastMeeting?.id ? firstInterview?.moduleGoal5FromLastMeeting?.id : null,
        moduleGoal6IdFromLastMeeting: firstInterview?.moduleGoal6FromLastMeeting?.id ? firstInterview?.moduleGoal6FromLastMeeting?.id : null,
        professionalBackgrounds: professionalBackgroundsData,
        educationalPaths: educationalPathsData,
        specialKnowledge: specialKnowledgeData,
        interests: interestsData,
      };

      // store original as a deep copy !!!
      originalFormData.value = JSON.parse(JSON.stringify(formData.value));
      originalModuleGoalDropdowns.value = JSON.parse(JSON.stringify(moduleGoalDropdowns));
    }
  } catch (error) {
    await ErrorToast(error);
  }

}


// Accordion
const toggleAccordion = (index) => {
  activeAccordion.value = activeAccordion.value === index ? null : index;
};

const addItem = (type, newItem) => {
  formData.value[type].push(newItem);
};

const removeItem = (type, index) => {
  formData.value[type].splice(index, 1);
};

const calculateTimeDifference = () => {

  if (formData.value.startTime && formData.value.endTime) {
    moduleInfoMessage.value = '';

    const [startHours, startMinutes] = formData.value.startTime.split(':').map(Number);
    const [endHours, endMinutes] = formData.value.endTime.split(':').map(Number);

    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    const diffMinutes = endTotalMinutes - startTotalMinutes;

    let units = (diffMinutes / 45).toPrecision(3).substring(0, 4);

    onChangeUnits(units); // Check if units are round

    const parsedValue = parseFloat(units);

    if (parsedValue === 1 || parsedValue === 2) { // Units must be 1 or 2
      units = (diffMinutes / 45).toPrecision(3).substring(0, 4);

      const [day, month, year] = formData.value.termin.split('.');
      const formatedTermin = `${year}-${month}-${day}`;

      if (
          isUnitsReduction.value &&
          formData.value.presence &&
          formData.value.presence !== 'anwesend' &&
          formatedTermin >= micNewUnitsCalculationStartFrom
      ) {
        units = 1;
      } else {
        units = (diffMinutes / 45).toPrecision(3).substring(0, 4);
      }

      onChangeModule(formData.value.moduleId);
    }

    formData.value.units = Number(units).toFixed(2);
  } else {
    formData.value.units = 0;
  }
};

function onChangeUnits(value) {
  // Parse value to a float
  const parsedValue = parseFloat(value);

  if (isNaN(parsedValue) || parsedValue <= 0) {
    unitsErrorMessage.value = 'Die Besprechungsdauer muss 45 Minuten oder 90 Minuten betragen.';
  } else if (!Number.isInteger(parsedValue)) {
    unitsErrorMessage.value = 'Die Besprechungsdauer muss 45 Minuten oder 90 Minuten betragen.';
  } else if (parsedValue > 2) {
    unitsErrorMessage.value = 'Die Besprechungsdauer muss 45 Minuten oder 90 Minuten betragen.';
  } else {
    unitsErrorMessage.value = '';
  }
}

async function onChangeTermin(newTermin) {

  if (isProcessingChangeTermin.value) return;
  isProcessingChangeTermin.value = true;

  try {
    // 1. Check if the last meeting is system added meeting
    formData.value.systemAddedMeetingDescription = '';
    if (newTermin) {

      const [day, month, year] = newTermin.split('.');
      const formattedDate = `${year}-${month}-${day}`;

      const {data} = await portalPrivateCoachingService.checkIsLastMeetingSystemAddedMeeting(
          +coachingId, formattedDate, firstInterviewId.value,
      );

      if (data?.data?.lastMeetingIsSystemAddedMeeting === true && coachingData?.value?.status !== 'new') {
        formData.value.systemAddedMeetingDescription = 'Über die durchgeführte Selbstlerneinheit wurde mit dem Teilnehmer gesprochen.';
      }
    }

    // 2. Check meeting presence
    await onChangePresence(formData.value.presence);

    // 3. Get goals from last meeting
    await getGoalFromLastMeeting();

    await calculateTimeDifference()
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isProcessingChangeTermin.value = false;
  }

}

async function onChangeModule(newValue) {
  try {
    if (newValue) {
      if (formData.value.moduleId !== newValue) {
        clearModuleData()
      }

      // const {data} = await portalPrivateCoachingService.getSumUnitsDoneForModule(
      //     +coachingId,
      //     +newValue,
      //     firstInterviewId.value,
      // );

      // const [errorMessage, infoMessage] = portalPrivateCoachingCheckModule(data, formData, updateAsAdmin.value);
      //
      // moduleInfoMessage.value = infoMessage;
      // moduleUnitsErrorMessage.value = errorMessage;

      const {data: goals} = await portalPrivateCoachingService.getGoalsOnChangeModuleOrGoal(+newValue);

      moduleGoal1Dropdown.value =
          goals?.data?.moduleGoals?.filter(item => item.shortName) // Exclude items with empty shortName
              .map(item => ({
                label: item.shortName,
                value: item?.id,
              }));

    } else {
      moduleInfoMessage.value = '';
      moduleUnitsErrorMessage.value = '';
      clearModuleData()
    }


    //await getGoalFromLastMeeting();
  } catch (error) {
    await ErrorToast(error);
  }
}

function clearModuleData() {
  formData.value.moduleGoal1Id = null;
  formData.value.moduleGoal2Id = null;
  formData.value.moduleGoal3Id = null;
  formData.value.moduleGoal4Id = null;
  formData.value.moduleGoal5Id = null;
  formData.value.moduleGoal6Id = null;
  formData.value.moduleGoalDate = null;

  moduleGoal1Dropdown.value = [];
  moduleGoal2Dropdown.value = [];
  moduleGoal3Dropdown.value = [];
  moduleGoal4Dropdown.value = [];
  moduleGoal5Dropdown.value = [];
  moduleGoal6Dropdown.value = [];
}

async function onChangeGoal(newValue, dropdownId) {
  const dropdowns = [
    moduleGoal1Dropdown,
    moduleGoal2Dropdown,
    moduleGoal3Dropdown,
    moduleGoal4Dropdown,
    moduleGoal5Dropdown,
    moduleGoal6Dropdown,
  ];

  const goalNames = {
    goal1Name,
    goal2Name,
    goal3Name,
    goal4Name,
    goal6Name,
  };

  for (let i = dropdownId + 1; i <= 6; i++) { // Reset goals ids
    formData.value[`moduleGoal${i}Id`] = null;
  }

  await handleGoalChange(
      +formData.value.moduleId,
      newValue,
      dropdownId,
      dropdowns,
      goalNames,
      portalPrivateCoachingService
  );
}

async function getGoalFromLastMeeting() {
  try {
    const {data} = await portalPrivateCoachingService.getGoalFromLastMeeting(
        {
          coachingId: +coachingId, // Must be int
          termin: formData.value.termin,
          meetingId: firstInterviewId.value !== '' ? +firstInterviewId.value : null,
        },
    );

    moduleGoal5LastMeetingDropdown.value = data?.data?.goal5DropdownFromLastMeetingData || [];
    moduleGoal6LastMeetingDropdown.value = data?.data?.goal6DropdownFromLastMeetingData || [];

    formData.value.moduleIdFromLastMeeting = data?.data?.lastMeetingModuleId;
    formData.value.previousMeetingId = data?.data?.lastMeetingId;
    formData.value.moduleGoal4IdFromLastMeeting = data?.data?.goal4IdFromLastMeeting;
    //formData.value.moduleGoal5IdFromLastMeeting = data?.data?.selectedGoal5FromLastMeeting;
    //formData.value.moduleGoal6IdFromLastMeeting = data?.data?.selectedGoal6FromLastMeeting;

  } catch (error) {
    await ErrorToast(error);
  }
}

async function onChangeGoalFromLastMeeting(newValue) {
  const {data} = await portalPrivateCoachingService.getGoalsOnChangeModuleOrGoal(
      formData.value.moduleIdFromLastMeeting, newValue,
  );

  moduleGoal6LastMeetingDropdown.value =
      data?.data?.moduleGoals?.filter(item => item.shortName)
          .map(item => ({
            label: item.shortName,
            value: item?.id,
          }));
}

async function onChangePresence(newValue) {

  if (newValue === 'unentschuldigt' || newValue === 'krank') {
    formData.value.moduleGoal1Id = null;
    formData.value.moduleGoal2Id = null;
    formData.value.moduleGoal3Id = null;
    formData.value.moduleGoal4Id = null;
    formData.value.moduleGoalDate = null;

    formRules.value = {
      ...formRules.value,
      moduleGoal1Id: '',
      moduleGoal2Id: '',
      moduleGoal3Id: '',
      moduleGoal4Id: '',
    };
  } else {
    formRules.value = {
      ...formRules.value,
      moduleGoal1Id: requiredRule(t),
      moduleGoal2Id: requiredRule(t),
      moduleGoal3Id: requiredRule(t),
      moduleGoal4Id: requiredRule(t),
    };
  }

  // api call
  const {data} = await portalPrivateCoachingService.checkMeetingPresenceOnChange({
    coachingId: +coachingId, // Must be int
    presence: newValue,
    termin: formData.value.termin,
    meetingId: firstInterviewId.value !== '' ? +firstInterviewId.value : null,
  });

  formData.value.presenceRemainder = '';
  formData.value.presenceRemainderAcceptance = '';
  showAdditionalDropdown.value = false;

  formData.value.presenceRemainder = data?.data?.text;
  showAdditionalDropdown.value = data?.data?.showAdditionalDropdown;

  calculateTimeDifference();
}

async function getEnumsDropdown() {
  presenceDropdown.value = getEnums?.value?.presenceTypes || [];
  doctorTypeDropdown.value = getEnums?.value?.doctorTypes || [];
  assistanceTypeDropdown.value = getEnums?.value?.assistanceTypes || [];
  graduationTypeDropdown.value = getEnums?.value?.graduationTypes || [];
}

async function getValuesFromAccordionDropdown() {
  resourceDropdown.value = generateResourcesDropdown();
  professionalSkillsDropdown.value = generateProfessionalSkillsDropdown();
  competenciesDropdown.value = generateCompetenciesDropdown();
  actionSkillsDropdown.value = generateActionSkillsDropdown();
  communicativeSkillsDropdown.value = generateCommunicativeSkillsDropdown();
  emotionalSkillsDropdown.value = generateEmotionalSkillsDropdown();
  socialSkillsDropdown.value = generateSocialSkillsDropdown();
}

function onChangeUpdateAsAdmin() {
  if (updateAsAdmin.value) {
    isBilled.value = false;
    isCoachBilled.value = false;

    formRules.value = {
      ...formRules.value,
      sectionNumber: requiredRule(t),
    }
  } else {
    // restore form data from original snapshot
    formData.value = JSON.parse(JSON.stringify(originalFormData.value));

    formData.value.startTime = originalFormData.value.startTime;
    startTimeKey.value = originalFormData.value.startTime + '_' + Date.now(); // Change the key to force re-render

    formData.value.endTime = originalFormData.value.endTime;
    endTimeKey.value = originalFormData.value.endTime + '_' + Date.now(); // Change the key to force re-render

    moduleGoal1Dropdown.value = originalModuleGoalDropdowns.value?.goal1Dropdown || [];
    moduleGoal2Dropdown.value = originalModuleGoalDropdowns.value?.goal2Dropdown || [];
    moduleGoal3Dropdown.value = originalModuleGoalDropdowns.value?.goal3Dropdown || [];
    moduleGoal4Dropdown.value = originalModuleGoalDropdowns.value?.goal4Dropdown || [];
    moduleGoal5Dropdown.value = originalModuleGoalDropdowns.value?.goal5Dropdown || [];
    moduleGoal6Dropdown.value = originalModuleGoalDropdowns.value?.goal6Dropdown || [];
    moduleGoal5LastMeetingDropdown.value = originalModuleGoalDropdowns.value?.goal5FromLastMeetingDropdown || [];
    moduleGoal6LastMeetingDropdown.value = originalModuleGoalDropdowns.value?.goal6FromLastMeetingDropdown || [];

    isBilled.value = originalIsBilled.value;
    isCoachBilled.value = originalIsCoachBilled.value;

    unitsErrorMessage.value = ''
    terminErrorMessage.value = ''
    moduleInfoMessage.value = ''
    moduleUnitsErrorMessage.value = ''

    formRules.value = {
      ...formRules.value,
      sectionNumber: '',
    }
  }
}

const canSeeCreateNewMeetingButton = computed(() => {
  if (currentUserRole === 'ROLE_ADMIN') {
    return true;
  } else {
    return true;
    // return missingDigitalSignatureMessage.value === null;
  }
});

function checkMissingMeetingForSectionNumber(sectionNumberList, sectionNumber) {
  return sectionNumberList?.[sectionNumber] ?? false;
}

const showUpdateAsAdminButton = computed(() =>
    // (currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') &&
    // (originalIsBilled.value || originalIsCoachBilled.value)
    (currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') &&
    firstInterviewId.value != null && firstInterviewId.value !== ''
);

function handleDigitalSignatureModal() {
  CloseToast();
  showDigitalSignatureModal.value = true;
  showMeetingHistoryModal.value = false;
}

function handleMeetingHistoryModal() {
  CloseToast();
  showMeetingHistoryModal.value = true;
  showDigitalSignatureModal.value = false;
}

function normalizeId(value) {
  if (value === '' || value === 'null' || value == null) {
    return null;
  }
  return Number(value);
}

const isResourcesAndSkillsValid = computed(() => {
  if (startValidateResourceAndSkills.value === true) {
    const resources = formData.value.resourceAndSkills;
    return resources.map(obj => {
      return Object.keys(obj)
          .filter(key => key !== 'description' && key !== 'id' && key !== 'title')
          .some(key => obj[key]?.trim() !== '' && obj[key]?.trim() !== "null" && obj[key] !== null);
    }).some(key => key === true);
  } else {
    return true
  }
});


onMounted(async () => {
  if(companyKey === "BBQ"){
    await router.push({name: 'privateCoachingNewAndActiveList'});
  }
  await Promise.all([
    getPrivateCoachingData(coachingId),
    getFirstInterviewData(coachingId),
    getAssignedCoachesForDropdown(coachingId, coachDropdown),
    getAssignedModulesForDropdown(coachingId, moduleDropdown),
    getEnumsDropdown(),
    getValuesFromAccordionDropdown(),
  ]);

  // this must be at the end !!!
  checkCoachingStartDateForMICV2(coachingData, coachingId)

  isLoaded.value = true;
});
</script>

<style scoped>

</style>